/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalculationCycleStatus = {
    Pending: 'Pending',
    Calculating: 'Calculating',
    CalculationFailed: 'CalculationFailed',
    Calculated: 'Calculated',
    Syncing: 'Syncing',
    SyncFailed: 'SyncFailed',
    Synced: 'Synced'
} as const;
export type CalculationCycleStatus = typeof CalculationCycleStatus[keyof typeof CalculationCycleStatus];


export function instanceOfCalculationCycleStatus(value: any): boolean {
    for (const key in CalculationCycleStatus) {
        if (Object.prototype.hasOwnProperty.call(CalculationCycleStatus, key)) {
            if (CalculationCycleStatus[key as keyof typeof CalculationCycleStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CalculationCycleStatusFromJSON(json: any): CalculationCycleStatus {
    return CalculationCycleStatusFromJSONTyped(json, false);
}

export function CalculationCycleStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationCycleStatus {
    return json as CalculationCycleStatus;
}

export function CalculationCycleStatusToJSON(value?: CalculationCycleStatus | null): any {
    return value as any;
}

export function CalculationCycleStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CalculationCycleStatus {
    return value as CalculationCycleStatus;
}

